<template>

  <form>
    <div class="form-group">
      <label>{{ $t('Email') }}</label>
      <input
        v-autofocus
        type="text"
        class="form-control"
        v-model="settings.email"
        maxlength="60">
      <ValidateMessage :error="validateErrors['settings.email']" />
    </div>
    <div class="form-group">
      <label>Tipo de candidatura</label>

      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="indeed_apply"
          value="indeed_apply"
          v-model="settings.apply_type">
        <label
          class="form-check-label"
          for="indeed_apply">
          Indeed Apply
        </label>
        <p class="text-muted">O candidate poderá se candidatar diretamente pelo Indeed (Recomendado)</p>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="redirect"
          value="redirect"
          v-model="settings.apply_type">
        <label
          class="form-check-label"
          for="redirect">
          Redirecionar
        </label>
        <p class="text-muted">O candidato é redirecionado para vaga na página de carreiras</p>
      </div>
      <ValidateMessage :error="validateErrors['settings.apply_type']" />
    </div>
  </form>

</template>

<script>
export default {
  name: 'IntegrationForm',
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    },
    validateErrors: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false,
      settings: this.$clone(this.value || {})
    }
  },
  watch: {
    settings: {
      handler: function (newValue) {
        this.$emit('input', newValue)
      },
      deep: true
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/IndeedForm.vue